/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
// import Axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import bg from "../img/bg.png";
// import { useNavigate } from "react-router-dom";
import "./PageLogin.css";

const PageRejister = () => {
  // const navigate = useNavigate();
  // const Ranks = [
  //   "ไม่ระบุ",
  //   "นาย",
  //   "นาง",
  //   "นางสาว",
  //   "จ.ต.",
  //   "จ.ต.หญิง",
  //   "จ.ท.",
  //   "จ.ท.หญิง",
  //   "จ.อ.",
  //   "จ.อ.หญิง",
  //   "พ.อ.ต.",
  //   "พ.อ.ต.หญิง",
  //   "พ.อ.ท.",
  //   "พ.อ.ท.หญิง",
  //   "พ.อ.อ.",
  //   "พ.อ.อ.หญิง",
  //   "ร.ต.",
  //   "ว่าที่ ร.ต.",
  //   "ร.ต.หญิง",
  //   "ว่าที่ ร.ต.หญิง",
  //   "ร.ท.",
  //   "ว่าที่ ร.ท.",
  //   "ร.ท.หญิง",
  //   "ว่าที่ ร.ท.หญิง",
  //   "ร.อ.",
  //   "ว่าที่ ร.อ.",
  //   "ร.อ.หญิง",
  //   "ว่าที่ ร.อ.หญิง",
  //   "น.ต.",
  //   "ว่าที่ น.ต.",
  //   "น.ต.หญิง",
  //   "ว่าที่ น.ต.หญิง",
  //   "น.ท.",
  //   "ว่าที่ น.ท.",
  //   "น.ท.หญิง",
  //   "ว่าที่ น.ท.หญิง",
  //   "น.อ.",
  //   "ว่าที่ น.อ.",
  //   "น.อ.หญิง",
  //   "ว่าที่ น.อ.หญิง",
  //   "พล.อ.ต.",
  //   "พล.อ.ต.หญิง",
  //   "พล.อ.ท.",
  //   "พล.อ.ท.หญิง",
  //   " พล.อ.อ.",
  //   "พล.อ.อ.หญิง",
  // ];
  // const Companys = [
  //   "ศบพ.",
  //   "ศฮพ.",
  //   "ศกอ.",
  //   "สพร.ทอ.",
  //   "สคม.ทอ.",
  //   "สลก.ทอ.",
  //   "สบ.ทอ.",
  //   "กพ.ทอ.",
  //   "ขว.ทอ.",
  //   "ยก.ทอ.",
  //   "กบ.ทอ.",
  //   "กร.ทอ.",
  //   "ทสส.ทอ.",
  //   "สปช.ทอ.",
  //   "กง.ทอ.",
  //   "จร.ทอ.",
  //   "สตน.ทอ.",
  //   "สนภ.ทอ.",
  //   "สธน.ทอ.",
  //   "ศซบ.ทอ.",
  //   "สบน.ทอ.",
  //   "คปอ.ทอ.",
  //   "อย.",
  //   "รร.การบิน",
  //   "บน.1",
  //   "บน.2",
  //   "บน.3",
  //   "บน.4",
  //   "บน.5",
  //   "บน.7",
  //   "บน.6",
  //   "บน.23",
  //   "บน.21",
  //   "บน.41",
  //   "บน.46",
  //   "บน.56",
  //   "ศปอว.ทอ.",
  //   "พธ.ทอ.",
  //   "ชอ.",
  //   "สอ.ทอ.",
  //   "สพ.ทอ.",
  //   "พอ.",
  //   "ขส.ทอ.",
  //   "ชย.ทอ.",
  //   "ศซว.ทอ.",
  //   "ยศ.ทอ.",
  //   "รร.นนก.",
  //   "ศวอ.ทอ.",
  //   "สก.ทอ.",
  //   "สน.ผบ.ดม.",
  //   "สวบ.ทอ.",
  // ];

  
  return (
    <>
      <Form>
        <div className="App login-box">
          <section
            style={{
              backgroundImage: `url(${bg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
            }}
          >
            <div className="container">
              <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4 ">
                <div className="container">
                  <div className="row justify-content-center py-2 h-100 ">
                    <div className="col-md-6 col-12d-flex flex-column align-items-center justify-content-center ">
                      {/* <!-- End Logo --> */}

                      <div className="card mb-5 rounded-3">
                        <div className="card-body ">
                          <div className="pt-4 pb-2">
                            
                            <h5 className="card-title text-center pb-0 fs-4 ">
                            
                            <a  href ="/"><i className="fa fa-chevron-circle-left" aria-hidden="true" ></i></a>
                            สมัครสมาชิก
                            </h5>
                          </div>
                          <hr></hr>
                          <div className="row g-3 needs-validation" >
                            <div className="pt-2 ps-6 input-group has-validation">
                              <div className="col-12">
                                <label htmlFor="ํyourNo" className="form-label">
                                  เลขประจำตัวประชาชน
                                  <label style={{ color: "red" }}>*</label>
                                </label>
                              </div>
                              <input
                                id="ํyourNo"
                                className="form-control"
                                name="No"
                                placeholder="กรุณากรอกเลขบัตรประชาชน และกดปุ่มค้นหา"
                                required
                              />
                              <span>
                                
                                <button                         
                                  type="button"
                                  className="btn btn-primary "
                                > <i className="fa fa-search-plus" aria-hidden="true"></i>
                                  ค้นหา
                                 
                                </button>
                               
                                
                              </span>
                            </div>

                            <div className="col-12">
                              <label htmlFor="ํyourRanks" className="form-label">
                                ยศ<label style={{ color: "red" }}>*</label>
                              </label>
                              <input
                                type="text"
                                name="Ranks"
                                className="form-control"
                                id="ํyourRanks"
                                required
                              />
                            </div>

                            <div className="col-12">
                              <label htmlFor="ํyourname" className="form-label">
                                ชื่อ<label style={{ color: "red" }}>*</label>
                              </label>
                              <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="ํyourname"
                                required
                              />
                            </div>

                            <div className="col-12">
                              <label htmlFor="ํyourlname" className="form-label">
                                นามสกุล<label style={{ color: "red" }}>*</label>
                              </label>
                              <input
                                type="text"
                                name="lname"
                                className="form-control"
                                id="ํyourlname"
                                required
                              />
                            </div>

                            <div className="col-12">
                              <label htmlFor="ํyourposition" className="form-label">
                                ตำแหน่ง<label style={{ color: "red" }}>*</label>
                              </label>
                              <input
                                type="text"
                                name="position"
                                className="form-control"
                                id="ํyourposition"
                                required
                              />
                            </div>

                            <div className="col-12">
                              <label htmlFor="ํyourposition" className="form-label">
                                สังกัด<label style={{ color: "red" }}>*</label>
                              </label>
                              <input
                                type="text"
                                name="position"
                                className="form-control"
                                id="ํyourposition"
                                required
                              />
                            </div>

                            <div className="col-12">
                              <label htmlFor="ํyourposition" className="form-label">
                                ช่วยงานที่ สังกัด
                                <label style={{ color: "red" }}>*</label>
                              </label>
                              <input
                                type="text"
                                name="position"
                                className="form-control"
                                id="ํyourposition"
                                required
                              />
                            </div>

                            <div className="col-12">
                              <label htmlFor="ํyourposition" className="form-label">
                                จำพวก<label style={{ color: "red" }}>*</label>
                              </label>
                              <input
                                type="text"
                                name="position"
                                className="form-control"
                                id="ํyourposition"
                                required
                              />
                            </div>

                            <div className="col-12">
                              <label htmlFor="ํyourposition" className="form-label">
                                วันเดือนปีเกิด (ตัวอย่าง 2022-06-04)
                                <label style={{ color: "red" }}>*</label>
                              </label>
                              <input
                                type="text"
                                name="position"
                                className="form-control"
                                id="ํyourposition"
                                required
                              />
                            </div>

                            <div className="col-12">
                              <label htmlFor="ํyourposition" className="form-label">
                                อีเมล ทอ.(ไม่ต้องใส่ @)
                                <label style={{ color: "red" }}>*</label>
                              </label>
                              <input
                                type="text"
                                name="position"
                                className="form-control"
                                id="ํyourposition"
                                required
                              />
                            </div>
                            <div className="col-12 pb-3 ps-4 pe-4 mt-4">
                                <Button className="btn btn-primary " type="submit" style={{ width: "100%" }}><b>สมัครสมาชิก</b></Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </section>
        </div>
      </Form>
    </>
  );
};
export default PageRejister;
